import { SUCCESS, ERROR } from './responseResult';


export const FETCH_SCHEMA_SUCCESS = `FETCH_SCHEMA_${SUCCESS}`;
export const FETCH_SCHEMA_ERROR = `FETCH_SCHEMA_${ERROR}`;
